var chunkToChildrenMap = {
	"945": [
		9764,
		5623
	],
	"7212": [
		9764,
		5623
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));